import { createContext, useContext, useEffect, useState } from 'react';

import fetcher, { Response } from '@/lib/utils/fetcherBasic';

type LiveContextType = {
  data?: {
    hasLive: boolean;
  };
  loading: boolean;
  error?: string;
};

type isLive = {
  is_live: boolean
}

const LiveDataContext = createContext<LiveContextType>({ loading: false });

export const useLiveDataContext = () => {
  return useContext(LiveDataContext);
};

export const DataLiveProvider = ({ children }: { children: React.ReactNode }) => {
  const [data, setData] = useState<isLive>({is_live: false});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  const fetchData = async () => {
    setLoading(true);
    const response = await fetcher<isLive>(`/api/islive`, {
      cache: 'no-store',
    });
    setLoading(false);

    if ((response as Response).message === 'error') {
      setData({is_live: false});
      setError(`Error fetching live data ${(response as Response).message}`);
    } else {
      setData(response as isLive);
    }
  };

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 120000);

    return () => clearInterval(intervalId);
  }, []);

  let hasLive = false;
  if (data) {
    hasLive = data.is_live;
  }

  const contextValue = {
    data: {
      hasLive,
    },
    loading,
    error,
  };

  return <LiveDataContext.Provider value={contextValue}>{children}</LiveDataContext.Provider>;
};
